import { Injectable } from '@angular/core';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { Subject } from 'rxjs';
import $ from 'jquery';
import { TicketTabType } from '../enums/ticket-tab-type.enum';
import { TicketRightPanelService } from './ticket-right-panel.service';
import { ThreadElementDTO } from '@sb-tools/typescript/models/dto/thread-element.dto';
import { NoteDTO } from '../models/dto/note.dto';

@Injectable({
    providedIn: 'root',
})
export class NoteService {
    allUsers = [];

    commentedReply: ThreadElementDTO;

    disableNoteHighlighting: boolean;

    ignoreParamNoteId = false;

    isReplyAlreadySelected: boolean;

    isEditorForNewNoteShown = false;

    newNoteModel = {
        text: '',
        html: '',
        attachments: [],
    };

    newNoteSubject = new Subject<any>();

    noteIdWithMentionedUser: number;

    referencedReply;

    editorWindowTopPosition: string;

    scrollToViewNote = new Subject<void>();

    updateStamp = new Subject<void>();

    constructor(private ticketRightPanelService: TicketRightPanelService) {}

    addNewNote(note) {
        this.newNoteSubject.next(note);
    }

    scrollToView() {
        this.scrollToViewNote.next();
    }

    openEditor(reply, isChatView?) {
        this.isEditorForNewNoteShown = false;

        this.commentedReply = reply;

        const replyContainerTopCoordinateInThread = $('#reply-id-' + reply.id)?.offset()?.top;
        const bottomPartOfRepliesContainer = 420;
        const extraPaddingAtTheBottom = 60;
        const isReplyAtTheBottomOfWindow = replyContainerTopCoordinateInThread > bottomPartOfRepliesContainer;

        this.editorWindowTopPosition =
            (isReplyAtTheBottomOfWindow
                ? replyContainerTopCoordinateInThread - extraPaddingAtTheBottom
                : replyContainerTopCoordinateInThread) -
            (isChatView
                ? $('#chat-thread-container').offset().top
                : $('#ticket-details-container-for-scroll').offset().top) +
            'px';

        this.newNoteModel = {
            text: '',
            html: '',
            attachments: [],
        };

        setTimeout(() => {
            this.isEditorForNewNoteShown = true;
        });
    }

    openNotes(ticket) {
        if (this.ticketRightPanelService.isRightPanelOpened) {
            this.ticketRightPanelService.onActivateTabSubject.next(TicketTabType.notes);
            this.scrollToView();
        } else {
            this.ticketRightPanelService.open({ ticket, tabType: TicketTabType.notes });
        }
    }

    findNote(notes: NoteDTO[], noteId: number): NoteDTO {
        if (notes.length) {
            return notes.find((note) => {
                if (note.id === noteId) {
                    return note;
                } else if (note.subNotes.length) {
                    return this.findNote(note.subNotes, noteId);
                }
            });
        } else {
            return null;
        }
    }

    getMentionedIds(type: 'user' | 'group', text: string): number[] | string[] {
        const entityIds = [];
        const wrapper = document.createElement('div');
        wrapper.innerHTML = text;

        const mentionsFromHtml = wrapper.getElementsByClassName(`mention-${type}`);

        Array.from(mentionsFromHtml).forEach((mentionElement) => {
            const entityId = mentionElement.getAttribute('data-mention-id');
            if (entityId) {
                entityIds.push(entityId);
            }
        });

        return entityIds;
    }

    // todo: check this method
    // todo: add return type
    getMentorIds(noteText: string) {
        let mentors = [];

        const wrapperId = 'temp-wrapper-for-note-mentions' + new Date().getTime();

        $('<div>', { id: wrapperId, style: 'display: none' }).appendTo('body');

        const htmlElements = $('#' + wrapperId);

        htmlElements[0].innerHTML = noteText;

        const mentorsFromHtml = htmlElements.find('.mention');

        for (const el of mentorsFromHtml) {
            let valText = el.textContent;
            if (!valText) {
                continue;
            }

            valText = valText.trim();

            if (valText.startsWith('@')) {
                valText = valText.substring(1);
            }

            if (HelperService.isEmailValid(valText)) {
                mentors.push(valText);
            }
        }

        htmlElements.remove();

        if (!mentors.length) {
            // tslint:disable-next-line:max-line-length
            mentors = noteText.match(
                /(@)(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})(?=\s|$)/g,
            );
        }

        if (mentors?.length) {
            mentors.forEach((email) => {
                const user = this.allUsers.find((existedUser) => {
                    return existedUser.email.toLowerCase() === email.toLowerCase();
                });

                if (
                    user &&
                    !mentors.find((mentor) => {
                        return mentor.id === user.id;
                    })
                ) {
                    mentors.push(user);
                }
            });

            return mentors
                .map((mentor) => mentor.id)
                .filter((mentorId) => {
                    return mentorId != null;
                });
        }

        return [];
    }

    getNoteWithProcessedMentions(text): string {
        const wrapper = document.createElement('div');
        wrapper.innerHTML = text;

        const groupMentionsFromHtml = wrapper.getElementsByClassName('mention-group');

        Array.from(groupMentionsFromHtml).forEach((mentionElement) => {
            const groupId = mentionElement.getAttribute('data-mention-id');
            if (groupId) {
                mentionElement.innerHTML = `{Group:${groupId}}`;
            }
        });

        const userMentionsFromHtml = wrapper.getElementsByClassName('mention-user');

        Array.from(userMentionsFromHtml).forEach((mentionElement) => {
            const userId = mentionElement.getAttribute('data-mention-id');
            if (userId) {
                mentionElement.innerHTML = `{User:${userId}}`;
            }
        });

        return wrapper.innerHTML;
    }
}
